module.exports = __webpack_public_path__ + "img/3.de5e50ab.webp";